function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#000000",
  d: "M129.31 16.82L239.1 52.84L238.01 56.23L239.12 52.84C240.98 53.45 242 55.46 241.37 57.32C241 58.52 240.03 59.37 238.9 59.65L129.11 95.68L129.11 95.69C128.29 95.96 127.43 95.91 126.69 95.62L16.88 59.58L17.99 56.23L16.88 59.6C15.02 58.99 14 56.98 14.61 55.12C15 53.92 15.97 53.08 17.1 52.79L126.89 16.77L126.89 16.75C127.71 16.48 128.56 16.53 129.31 16.82ZM226.65 56.23L128 23.86L29.35 56.23L128 88.58L226.65 56.23"
}), React.createElement("path", {
  fill: "#000000",
  d: "M202.9 71.47L168.07 82.9L168.07 82.9C167.21 83.19 166.33 83.12 165.56 82.8L62.17 44.66L63.39 41.33L62.15 44.66C60.31 43.98 59.37 41.94 60.05 40.11C60.47 38.98 61.4 38.17 62.47 37.91L97.3 26.48L97.3 26.46C98.16 26.19 99.03 26.24 99.8 26.58L203.22 64.72L201.98 68.04L203.22 64.7C205.06 65.38 205.99 67.43 205.31 69.27C204.9 70.4 203.97 71.19 202.9 71.47ZM167.03 75.77L191.22 67.84L98.34 33.59L74.15 41.52L167.03 75.77"
}), React.createElement("path", {
  fill: "#000000",
  d: "M19.14 194.79C17.28 194.14 15.27 195.13 14.63 196.99C14 198.84 14.99 200.86 16.83 201.49L126.85 239.23L126.85 239.23C127.66 239.52 128.52 239.48 129.27 239.2L239.15 201.49C241.01 200.86 242 198.84 241.37 196.99C240.73 195.13 238.7 194.14 236.86 194.79L128 232.12L19.14 194.79"
}), React.createElement("path", {
  fill: "#000000",
  d: "M241.55 56.23C241.55 54.26 239.98 52.67 238.01 52.67C236.05 52.67 234.46 54.26 234.46 56.23L234.46 198.14C234.46 200.09 236.05 201.69 238.01 201.69C239.98 201.69 241.55 200.09 241.55 198.14L241.55 56.23"
}), React.createElement("path", {
  fill: "#000000",
  d: "M21.54 56.23C21.54 54.26 19.95 52.67 17.99 52.67C16.02 52.67 14.43 54.26 14.43 56.23L14.43 198.14C14.43 200.09 16.02 201.69 17.99 201.69C19.95 201.69 21.54 200.09 21.54 198.14L21.54 56.23"
}), React.createElement("path", {
  fill: "#000000",
  d: "M131.55 92.31C131.55 90.36 129.95 88.76 128 88.76C126.05 88.76 124.45 90.36 124.45 92.31L124.45 235.88C124.45 237.84 126.05 239.43 128 239.43C129.95 239.43 131.55 237.84 131.55 235.88L131.55 92.31"
}), React.createElement("path", {
  fill: "#000000",
  d: "M37.45 178.88C35.59 178.24 33.58 179.22 32.93 181.09C32.31 182.93 33.29 184.96 35.14 185.58L50.97 191.01C52.82 191.65 54.84 190.67 55.47 188.81C56.11 186.96 55.11 184.94 53.27 184.31L37.45 178.88"
}), React.createElement("path", {
  fill: "#000000",
  d: "M166.08 76.1L200.89 64.69L200.89 64.69C202.75 64.08 204.76 65.08 205.37 66.94C205.49 67.34 205.55 67.73 205.55 68.12L205.55 102.3C205.55 103.95 204.42 105.33 202.88 105.72L168.13 117.85L168.14 117.87C166.28 118.51 164.26 117.53 163.61 115.68C163.47 115.27 163.41 114.86 163.41 114.45L163.41 79.54C163.41 77.87 164.54 76.49 166.08 76.1ZM198.43 72.94L170.51 82.1L170.51 109.54L198.43 99.8L198.43 72.94"
})));

var SvgPackage = function SvgPackage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPackage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Package.8d7d39f5.svg";
export { ForwardRef as ReactComponent };